module.exports = __webpack_public_path__ + "static/img/cart.db98cbfe.svg";